import {
  CreateButton,
  DateField,
  Icons,
  List,
  RefreshButton,
  Space,
  Table,
  Tag,
  useModalForm,
  message,
  useTable,
  Typography,
  EditButton,
  Button,
  ShowButton,
} from '@pankod/refine-antd'
import dayjs from 'dayjs'
import React, { useState, useEffect } from 'react'
import { Q_GET_SUPPORT_USERS } from 'gql/queries'
import { nhost } from 'utility'
import { useCreateMany, useGetIdentity, useNavigation, useUpdate } from '@pankod/refine-core'
import { useQuery } from '@tanstack/react-query'
import SupportTaskCreate from './create'
import SupportTaskEdit from './edit'
import { useUserContext } from 'context/user'
import PopupModal from 'components/PopupModal'

import Permissions from 'permissions'

const { PlusOutlined } = Icons

interface ISupportusers {
  id: string
  displayName: string
}

type Permission = {
  granted?: boolean
}

const SupportTaskList: React.FC = () => {
  const { userRole } = useUserContext()
  const { push } = useNavigation()
  const { mutateAsync: createMany } = useCreateMany()
  // id, uid,
  // task_name
  // map maanger_id
  // task_status "completed","in_progress","retire"
  // task_percent
  // created_at
  // due_date & time_interval
  // task assignee
  // after adding the task send notification to assignee in event trigger.
  // when task timing going to be end notify the support user through notification
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [modulePermissions, SetModulePermissions] = useState<any>(null)
  // const [createPermission, setCreatePermission] = useState<Permission>({})
  // const [editPermission, setEditPermission] = useState<Permission>({})
  // const [deletePermission, setDeletePermission] = useState<Permission>({})
  const { data: manager } = useGetIdentity()
  const manager_id = manager?.id
  const { show } = useNavigation()
  //   create modal form
  const {
    modalProps: createModalProps,
    formProps: createFormProps,
    show: createShow,
    close: createClose,
  } = useModalForm({
    action: 'create',
    resource: 'support_tasks',
    metaData: {
      fields: [
        'id',
        'name',
        'start_date',
        'end_date',
        'module_id',
        'assignee_id',
        'created_by',
        'description',
        // {
        //   permissions: ['id', 'task_id', 'support_id', 'module_id', 'can_create', 'can_read', 'can_update', 'can_delete'],
        // },
      ],
    },
    successNotification: false,
    redirect: false,
    onMutationSuccess: async data => {
      // console.log('new_task_data', data?.data)
      const task_id = data?.data?.id
      const support_id = data?.data?.assignee_id
      const transformpermission =
        modulePermissions?.length > 0 &&
        modulePermissions?.map((module: any) => ({
          module_id: module?.value,
          can_create: module?.can_create,
          can_read: module?.can_read,
          can_update: module?.can_update,
          can_delete: module?.can_delete,
          task_id,
          support_id,
        }))
      await createMany(
        {
          resource: 'permissions',
          values: transformpermission,
          successNotification: false,
        },
        {
          onSuccess: data => {
            message.open({
              type: 'success',
              content: 'New task created Successfully',
            })
          },
        }
      )
    },
  })
  const {
    modalProps: editModalProps,
    formProps: editFormProps,
    show: editShow,
    close: editClose,
    formLoading,
  } = useModalForm({
    action: 'edit',
    resource: 'support_tasks',
    metaData: {
      fields: ['id', 'name', 'start_date', 'end_date', 'module_id', 'assignee_id', 'created_by', 'description'],
    },
    successNotification: false,
    redirect: false,
    onMutationSuccess: data => {
      // console.log('task_data', data)
      message.open({
        type: 'success',
        content: 'Task Updated Successfully',
      })
    },
  })
  //   get assignees
  const { isLoading, data: sdata } = useQuery(['users'], async () => {
    const res: any = await nhost.graphql.request(Q_GET_SUPPORT_USERS, {
      where: {
        // _and: [{ metadata: { _contains: { createdBy: manager_id } } }],
        // _and: [{ roles: { _eq: 'systemsupport' } }],
        roles: { role: { _eq: 'systemsupport' } },
      },
    })
    return res?.data
  })
  const support_data =
    sdata?.users?.length > 0 &&
    sdata?.users?.map((d: any) => ({
      label: d?.displayName,
      value: d?.id,
    }))
  console.log('support_users', support_data)

  // table data for tasks
  const { tableProps } = useTable({
    resource: 'support_tasks',
    metaData: {
      fields: [
        'id',
        'uid',
        'active',
        'name',
        'start_date',
        'end_date',
        'assignee_id',
        'status',
        {
          assignee_user_details: ['id', 'displayName'],
        },
        'module_id',
        {
          module: ['id', 'label', 'value'],
        },
        'created_by',
        {
          created_by_user_details: ['id', 'displayName'],
        },
        {
          permissions: ['id', 'active'],
        },
      ],
    },
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter: [
      {
        field: 'created_by',
        operator: 'eq',
        value: manager_id,
      },
    ],
  })

  const columns: any = [
    {
      title: 'Task Id',
      dataIndex: 'uid',
    },
    {
      title: 'Name',
      render: (record: any) => {
        return (
          <ShowButton size="small" type="link" icon={null} recordItemId={record?.id} onClick={() => show('support/tasks', record?.id)}>
            {record?.name}
          </ShowButton>
        )
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (value: any) => (
        <Tag
          color={
            value === 'Assigned'
              ? 'cyan'
              : value === 'Completed'
              ? 'green'
              : value === 'In Progress'
              ? 'blue'
              : value === 'Expired'
              ? 'volcano'
              : 'geekblue'
          }
        >
          {value}
        </Tag>
      ),
    },
    {
      title: 'Assignee',
      dataIndex: 'assignee_user_details',
      render: (record: any) => <Typography.Text>{record?.displayName}</Typography.Text>,
    },
    {
      title: 'Start Date',
      dataIndex: 'start_date',
      render: (value: any) => <DateField format="DD-MMM-YY" value={value} />,
    },
    {
      title: 'Due Date',
      dataIndex: 'end_date',
      render: (value: any) => <DateField format="DD-MMM-YY" value={value} />,
    },
    {
      title: 'Created By',
      dataIndex: 'created_by_user_details',
      render: (record: any) => <Typography.Text>{record?.displayName}</Typography.Text>,
    },
    {
      title: 'Actions',
      render: (record: any) => {
        const isAfter = dayjs().isAfter(record?.end_date, 'day')
        return (
          <Space>
            <EditButton
              size="small"
              recordItemId={record?.id}
              onClick={() => {
                editShow(record?.id)
              }}
              disabled={(record?.status === 'Retired' && record?.active === false) || record?.status === 'Completed' || isAfter}
            />
          </Space>
        )
      },
    },
  ]
  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) push('/')
    // console.log(readPermission, 'readpermission')
  }, [readPermission])
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('support_tasks'))
      // setCreatePermission(Permissions.can(userRole).createAny('support_tasks'))
      // setEditPermission(Permissions.can(userRole).updateAny('support_tasks'))
      // setDeletePermission(Permissions.can(userRole).deleteAny('support_tasks'))
    }
  }, [userRole])
  // console.log('module_permissions', modulePermissions)
  return (
    <>
      <List
        pageHeaderProps={{
          extra: [userRole === 'srmanager' && <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => createShow()} />],
          title: 'Tasks',
        }}
      >
        <Table
          size="small"
          {...tableProps}
          columns={columns}
          dataSource={tableProps?.dataSource}
          rowKey="id"
          pagination={{
            ...tableProps?.pagination,
            showSizeChanger: true,
            pageSize: 10,
          }}
        />
      </List>
      <SupportTaskCreate
        modalProps={createModalProps}
        formProps={createFormProps}
        users={support_data}
        managerId={manager_id}
        close={createClose}
        permission={modulePermissions}
        onChangePermission={(data: any) => {
          SetModulePermissions(data)
        }}
      />
      <SupportTaskEdit
        modalProps={editModalProps}
        formProps={editFormProps}
        users={support_data}
        managerId={manager_id}
        close={editClose}
        loading={formLoading}
      />
    </>
  )
}

export default SupportTaskList
